import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { UPDATE_TINT_SERVICE_QUANTITY_FOR_ACTIVE_COLOR } from 'features/product-info/ducks/product-tint-service';
import { TINT_SERVICE_QUANTITY_FOR_ACTIVE_COLOR_UPDATED_EVENT } from '../constants';

export const useTintServiceQuantityForSelectedColorUpdated = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const onUpdatedEvent = (e: Event) => {
      if (Number.isFinite((e as CustomEvent).detail)) {
        const newQuantityForSelectedColor = (e as CustomEvent).detail;
        dispatch(UPDATE_TINT_SERVICE_QUANTITY_FOR_ACTIVE_COLOR(newQuantityForSelectedColor));
      }
    };
    document.body.addEventListener(TINT_SERVICE_QUANTITY_FOR_ACTIVE_COLOR_UPDATED_EVENT, onUpdatedEvent);

    return () => {
      document.body.removeEventListener(
        TINT_SERVICE_QUANTITY_FOR_ACTIVE_COLOR_UPDATED_EVENT,
        onUpdatedEvent,
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
